import i18n from '@service/I18nService';
import { textCapitalize } from './textConverter';

export const getNameTrl = (value: any) => {
  return value['name' + textCapitalize(i18n.language)] || value?.name;
};
